<template>
  <main class="posters resources__page-topic">
    <div class="resources__top-wrap">
      <RichRenderer :richTextData="cPage?.fields?.paragraphRich" />
      <form action class="resources__form" @submit.prevent="doSearch">
        <div class="resources__form-container form-input-wrapper--secondary">
          <input
            v-model="search"
            type="search"
            class="form-input form-input--small resources__search"
          />
          <app-button type="submit" value="Search" size="small" class="resources__form-submit" />
        </div>
      </form>
    </div>
    <div class="resources__content-list">
      <div
        v-for="(item, n) in posters"
        :key="`${item.title}-${n}`"
        :ref="item.title"
        class="resources__content-item"
      >
        <a
          :href="item.payloadUrl"
          class="resources__content-item-title text-link"
          target="_blank"
          v-html="item.title"
        />
        <p class="text-description" v-html="item.description" />
      </div>
    </div>
  </main>
</template>
<script>
import { useNavigation } from '@/composables/useNavigation'
import { usePageMeta } from '@/composables/usePageMeta'
import { useSearch } from '@/composables/useSearch'
import { useTransformEntries } from '@/composables/useTransformEntries'
export default {
  name: 'Posters',
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { anchorToEntry } = useNavigation()
    const { setPageMeta } = usePageMeta()
    const { fetchResources } = useSearch()
    const { transformEntries } = useTransformEntries()

    setPageMeta(props.cPage?.fields?.pageMeta)

    return {
      anchorToEntry,
      fetchResources,
      transformEntries,
    }
  },
  data() {
    return {
      search: '',
      posters: [],
    }
  },
  watch: {
    search() {
      this.doSearch()
    },
  },
  mounted() {
    this.doSearch().then(() => {
      this.anchorToEntry(this.posters, this.$refs)
    })
  },
  methods: {
    doSearch() {
      return this.fetchResources({
        query: this.search,
        filters: `resourceGroup:${this.cPage?.fields?.title} AND contentType:resource`,
        hitsPerPage: 1000,
      }).then((res) => {
        const postersList = this.transformEntries(res.hits).sort((a, b) => {
          if (a.date === b.date) return 0
          else if (a === null) return 1
          else if (b === null) return -1
          else return a.date < b.date ? 1 : -1
        })
        this.posters = postersList.filter((item) => item.payloadUrl)
      })
    },
  },
}
</script>
